export default {
	data() {
		return {
			STATUS: Object.freeze({
				Disabled: -1,
				Default: 0,
				Valid: 1,
				Invalid: 2,
			}),
		};
	},
	methods: {
		validator(value, name) {
			const patterns = {
				email: /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/,
				password: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{6,}$/,
				phone: /^(\+7|8)?[\s\-]?\(?\d{3}\)?[\s\-]?\d{3}[\s\-]?\d{2}[\s\-]?\d{2}$/,
			};

			const pattern = patterns[name];

			return pattern?.test(value) == true;
		},
	},
};
